<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Upload Image</v-card-title>

        <v-card-text>
            <h3 style="margin-bottom: 15px; margin-top: 15px">Format</h3>
            <p>Images must be square, in JPG or PNG format.  Images should be at least 400 pixels wide / high.</p>

            <p>If you need a tool to crop your images, take a look at <a href="https://avatarcropper.com/" target="_blank">Avatar Cropper</a>.</p>

            <h3 style="margin-bottom: 15px;">Disclaimer</h3>

            <p>Before using any image, make sure that you have all the required rights to do so.  
                If you are using stock images, make sure that you have properly licenced the images.
                If you are using employee headshots, make sure you have obtained all required rights from them (in writing).
            </p>
            <p>
                By checking the box below, you represent that you have all rights required to use the images you upload for their intended purpose and agree to indemnify, defend and hold harmless RedChirp LLC from any claims arising from the use of these image(s).
            </p>

            <v-checkbox
                label="I agree"
                v-model="agree"
            />

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!agree"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            agree: false,
            after_ok: null,
        }
    },

    methods: {

        showDialog(after_ok)
        {
            this.after_ok = after_ok;
            this.agree = false;
            this.dialog = true;

        },

        onOk()
        {
            this.dialog = false;

            if ( this.after_ok != null )
                this.after_ok();
        },

        onCancel()
        {
            this.dialog = false;
        },

        

    },
}
</script>

<style lang="scss" scoped>
</style>